import CodeIcon from '@mui/icons-material/Code';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import FormatStrikethroughIcon from '@mui/icons-material/FormatStrikethrough';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import NotesIcon from '@mui/icons-material/Notes';
import RedoIcon from '@mui/icons-material/Redo';
import UndoIcon from '@mui/icons-material/Undo';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { useCurrentEditor } from '@tiptap/react';
import React from 'react';

const ToolbarEditor = ({ _editor, _handleLink }) => {
  const { editor } = useCurrentEditor();
  const handleLink = () => {
    const link = window.prompt('Ajouter un lien');
    if (link && editor) {
      editor.chain().focus().setLink({ href: link }).run();
    }
  };

  return (
    <>
      <Grid
        container
        className="toolbar"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleBold().run()}
          size="small"
        >
          <Tooltip title="Gras">
            <FormatBoldIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleItalic().run()}
          size="small"
        >
          <Tooltip title="Italique">
            <FormatItalicIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleStrike().run()}
          size="small"
        >
          <Tooltip title="Barrer">
            <FormatStrikethroughIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          size="small"
        >
          <Tooltip title="Souligner">
            <FormatUnderlinedIcon />
          </Tooltip>
        </IconButton>
        <IconButton color="primary" onClick={() => handleLink()} size="small">
          <Tooltip title="Insérer un lien">
            <InsertLinkIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 3 }).run()
          }
          size="small"
        >
          <Tooltip title="Titre">
            <FormatSizeIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().setTextAlign('center').run()}
          size="small"
        >
          <Tooltip title="Aligner au centre">
            <FormatAlignCenterIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().setTextAlign('justify').run()}
          size="small"
        >
          <Tooltip title="Justifier">
            <FormatAlignJustifyIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().setTextAlign('left').run()}
          size="small"
        >
          <Tooltip title="Aligner à gauche">
            <FormatAlignLeftIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().setTextAlign('right').run()}
          size="small"
        >
          <Tooltip title="Aligner à droite">
            <FormatAlignRightIcon />
          </Tooltip>
        </IconButton>
        {/* FIXME: les boutons ne fonctionnent pas */}
        {/* <IconButton color="primary" size="small">
          <Tooltip title="Plus tard">
            <FormatColorFillIcon />
          </Tooltip>
        </IconButton>
        <IconButton color="primary" size="small">
          <Tooltip title="Plus tard">
            <FormatColorTextIcon />
          </Tooltip>
        </IconButton> */}
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleCode().run()}
          size="small"
        >
          <Tooltip title="Bloc de code">
            <CodeIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().unsetAllMarks().run()}
          size="small"
        >
          <Tooltip title="Supprimer le style">
            <FormatClearIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          size="small"
        >
          <Tooltip title="Liste à point">
            <FormatListBulletedIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          size="small"
        >
          <Tooltip title="Liste numérotée">
            <FormatListNumberedIcon />
          </Tooltip>
        </IconButton>
        <IconButton color="primary" disabled size="small">
          <NotesIcon />
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
          size="small"
        >
          <Tooltip title="Bloc de commentaire">
            <FormatQuoteIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().undo().run()}
          size="small"
        >
          <Tooltip title="Revenir en arrière">
            <UndoIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => editor.chain().focus().redo().run()}
          size="small"
        >
          <Tooltip title="Revenir en avant">
            <RedoIcon />
          </Tooltip>
        </IconButton>
      </Grid>
    </>
  );
};

export default ToolbarEditor;
